import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { getProgramUnits } from "../services/soar";
import FloatingInput from "../common/FloatingInput";

function ApartmentModal({ data, setData, show, handleSave, onHide }) {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    getPUs();
  }, []);

  const getPUs = async () => {
    const resp = await getProgramUnits(
      JSON.parse(localStorage.getItem("safyInfo")).user.safyInfo
        .BusinessUnitIdName
    );
    const options = resp
      .filter(
        (unit) =>
          !unit.ccx_expdate &&
          unit.ccx_programtype["@name"] === "Independent Living"
      )
      ?.map((unit) => ({
        _id: unit.ccx_unitid,
        name: unit.ccx_name,
      }));
    setOptions(options);
  };

  return (
    <Modal show={show} onHide={onHide} animation={false} size="lg">
      <Modal.Header closeButton className="bg-safy-info text-white">
        <Modal.Title>Apartment Information</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-safy2-4">
        <FloatingInput
          className="card-safy mb-2"
          label="Address"
          name="Address"
          value={data.address}
          onChange={(e) => setData({ ...data, address: e.target.value })}
        />
        <FloatingInput
          className="card-safy mb-2"
          label="Unit Number"
          name="Unit"
          value={data.unit}
          onChange={(e) => setData({ ...data, unit: e.target.value })}
        />
        <FloatingInput
          className="card-safy mb-2"
          label="City"
          name="City"
          value={data.city}
          onChange={(e) => setData({ ...data, city: e.target.value })}
        />
        <FloatingInput
          className="card-safy mb-2"
          label="State"
          name="State"
          value={data.state}
          onChange={(e) => setData({ ...data, state: e.target.value })}
        />
        <FloatingInput
          className="card-safy mb-2"
          label="Zip Code"
          name="zip"
          value={data.zip}
          onChange={(e) => setData({ ...data, zip: e.target.value })}
        />
        <FloatingInput
          className="card-safy mb-2"
          label="Door Code"
          name="DoorCode"
          value={data.doorCode}
          onChange={(e) => setData({ ...data, doorCode: e.target.value })}
        />
        <FloatingInput
          className="card-safy mb-2"
          label="Apartment Complex Name"
          name="Name"
          value={data.name === data.address ? "" : data.name}
          onChange={(e) => setData({ ...data, name: e.target.value })}
        />
        <FloatingInput
          type="select"
          className="card-safy mb-2"
          label="Program Unit"
          name="ProgramUnit"
          value={data.programUnit}
          options={options}
          onChange={(e) => {
            setData({
              ...data,
              programUnit: e.target.value,
              programUnitName: options.find((opt) => opt._id === e.target.value)
                .name,
            });
          }}
        />
      </Modal.Body>
      <Modal.Footer className="bg-safy2-4">
        <div
          className="btn btn-sm btn-success"
          onClick={() => {
            handleSave().then((response) => {
              if (response.code === "success") {
                toast.success("Saved successfully!");
                setData(data);
                onHide(response);
              } else {
                toast.error(response.message);
              }
            });
          }}
        >
          Save
        </div>
        <div className="btn btn-sm btn-danger" onClick={() => onHide()}>
          Cancel
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ApartmentModal;
